import classnames from "classnames";
import { inject } from "mobx-react";
import React from "react";
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton } from "react-share";
import type { SharePlatform, Store } from "../../../../client/stores";
import { ClickSection } from "../../lib/clickSection";
import { EmailButton } from "./EmailButton.component";
import { NativeShareButton } from "./NativeShareButton.component";
import { PrintButton } from "./PrintButton.component";
import "./ShareButtons.style.scss";

export interface ShareButtonsProps {
    url?: string;
    title?: string;
    desc?: string;
    className?: string;
    store?: Store;
    setStyles?: boolean;
}

export const ShareButtons = inject("store")(
    ({ className, desc, title, url = "", setStyles = true, store }: ShareButtonsProps) => {
        const classNames = className ? className.split(" ") : [];
        const iconSize = 40;
        const fill = "#ffffff";
        const bgStyle = {
            fill: "#27292D",
        };
        // #3B5998 - FB mouse hover

        const clickHandler = (platform: SharePlatform, sectionName = "") => {
            if (store) {
                store.onShareAction.dispatch({
                    share: {
                        platform,
                    },
                    sectionName,
                    pageName: store.page.currentPage
                        ? `${store.microsite ? "microsite_" : ""}${store.page.currentPage.name}`
                        : "",
                    context: "",
                    action: "share",
                    url,
                });
            }
        };

        return (
            <div className={classnames("share-icons", classNames)}>
                <ClickSection.Consumer>
                    {sectionName => (
                        <FacebookShareButton
                            data-platform={"facebook"}
                            quote={desc}
                            hashtag={`#${title}`}
                            url={url}
                            aria-label="Share this page on Facebook"
                            onClick={() => clickHandler("facebook", sectionName)}
                        >
                            <FacebookIcon
                                round={true}
                                size={iconSize}
                                iconFillColor={setStyles ? fill : ""}
                                bgStyle={setStyles ? bgStyle : {}}
                            />
                        </FacebookShareButton>
                    )}
                </ClickSection.Consumer>
                <ClickSection.Consumer>
                    {sectionName => (
                        <TwitterShareButton
                            data-platform={"twitter"}
                            title={title}
                            url={url}
                            aria-label="Share this page on Twitter"
                            onClick={() => clickHandler("twitter", sectionName)}
                        >
                            <TwitterIcon
                                round={true}
                                size={iconSize}
                                iconFillColor={setStyles ? fill : ""}
                                bgStyle={setStyles ? bgStyle : {}}
                            />
                        </TwitterShareButton>
                    )}
                </ClickSection.Consumer>
                <ClickSection.Consumer>
                    {sectionName => (
                        <EmailButton
                            subject={title}
                            body={desc}
                            url={url}
                            callback={() => clickHandler("email", sectionName)}
                        />
                    )}
                </ClickSection.Consumer>
                <ClickSection.Consumer>
                    {sectionName => (
                        <PrintButton
                            width={iconSize}
                            height={iconSize}
                            callback={() => clickHandler("print", sectionName)}
                        />
                    )}
                </ClickSection.Consumer>
                <ClickSection.Consumer>
                    {sectionName => (
                        <NativeShareButton
                            title={title}
                            url={url}
                            callback={() => clickHandler("native", sectionName)}
                        />
                    )}
                </ClickSection.Consumer>
            </div>
        );
    },
);
